import markUrl from "@/assets/afell-mark.png";
import { cn } from "@/lib/utils";

/**
 * The AFELL mark, from Soft Network's logo assets (240815_AFELL_logo_assets_v2).
 *
 * The mark alone rather than the full lockup, which sets the acronym's
 * expansion beside it — that reads as repetition next to headings and footers
 * that already spell it out. The lockup is the better choice anywhere the name
 * appears on its own.
 *
 * It is flat #00ADEF on transparency, so it reads on both themes untouched.
 */
export function AfellMark({ className }: { className?: string }) {
  return (
    <img
      src={markUrl}
      alt=""
      aria-hidden="true"
      className={cn("size-8 object-contain", className)}
    />
  );
}
